// Written by scripts/capture_product_screenshots.py on every capture — busts browser/CDN caches.
export const SHOTS_VERSION = '20260919-2311';
